import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ILowerLimitField {
	changeLowerLimit: (value: string) => void;
}

const LowerLimitField: React.FC<ILowerLimitField> = ({ changeLowerLimit }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterLowerLimit') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeLowerLimit(onlyDigits);
			return onlyDigits;
		},
		[changeLowerLimit],
	);

	return (
		<FormInput
			testId="LowerLimitField"
			name="lowerLimit"
			label="lowerLimitLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(LowerLimitField);
